import React from 'react';
import { SectionHeading } from './SectionHeading';
import { hardDays, planningSpiral } from '../data/copy';
export function ProblemSection() {
  return <section className="w-full bg-sand py-14 sm:py-16" aria-labelledby="problem-heading" data-id="element-157" data-mp="2lu4l19ttx630">
      <div className="mx-auto max-w-5xl px-6" data-id="element-158" data-mp="30iip1o2zf0l5">
        <SectionHeading eyebrow="The core problem" title={<span id="problem-heading" data-id="element-160" data-mp="2vp6daejeio9t">
              Does this look like your teaching week?
            </span>} lead={<>
              You finish teaching one class — and almost immediately another
              question appears:{' '}
              <span className="font-medium text-ink" data-id="element-161" data-mp="3jftn55cvnnz0">
                “What am I going to teach next?”
              </span>
            </>} data-id="element-159" data-mp="2vpzbgr4ao5gc" />

        <ul className="mx-auto mt-9 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-162" data-mp="3eiaa28rx1h8n">
          {planningSpiral.map(line => <li key={line} className="rounded-full border border-line bg-ivory px-4 py-2 font-sans text-[0.8rem] text-stone" data-id="element-163" data-mp="1p2kknxir12q9">
              {line}
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-164" data-mp="je6dotpfma6a">
          <p className="font-display text-2xl leading-snug text-ink" data-id="element-165" data-mp="oc7xjguomdit">
            And suddenly, planning a 60-minute class has taken a big piece of
            your evening.
          </p>
          <p className="mx-auto mt-4 max-w-readable font-sans text-[0.95rem] leading-relaxed text-stone" data-id="element-166" data-mp="sbyrftfi99rk">
            Not because you don’t know yoga — but because you’re rebuilding
            something every single week that could already be organized for you.
          </p>
        </div>

        <div className="mt-12 rounded-4xl bg-terracotta-light/70 px-6 py-9 sm:px-10" data-id="element-167" data-mp="174sk6gjsfme6">
          <h3 className="text-center font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-168" data-mp="1c2ka550vgyfq">
            And then there are the days when…
          </h3>
          <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-169" data-mp="3dtxf1u2ub6bs">
            {hardDays.map(day => <li key={day} className="rounded-full bg-shell px-4 py-2 font-sans text-[0.8rem] text-ink/80" data-id="element-170" data-mp="3hvsf6v91bdnz">
                {day}
              </li>)}
          </ul>
          <p className="mx-auto mt-8 max-w-xl text-center font-display text-xl leading-snug text-terracotta" data-id="element-171" data-mp="k15w87msr473">
            Yoga Teaching Vault™ was created for those moments.
          </p>
        </div>
      </div>
    </section>;
}